import { createSlice } from '@reduxjs/toolkit';
import typ from './index.d';
import Cookies from 'js-cookie';
import { AdvisorData } from '../../../services/requests/advisor/index.d';

const initialState: typ.Props = {
  isLogged: false,
  user: null,
};

export const statusSlice = createSlice({
  name: 'status',
  initialState,
  reducers: {
    signIn: state => {
      state.isLogged = true;
    },
    setCurrentUser: (state, { payload }: typ.setCurrentUserAction) => {
      state.user = payload;
    },
    setImage: (state, { payload }: typ.setImage) => {
      if(state.user) state.user.image = payload;
    },
    checkAuth: state => {
      let user = Cookies.get('user');
      if(user) {
        let currentUser = JSON.parse(user || '') 
        state.isLogged = true
        state.user = { ...currentUser }
      }
    },
    signOut: () => initialState,
  },
});

// Action creators are generated for each case reducer function
export const statusActions = statusSlice.actions;

export default statusSlice.reducer;
